<template>
  <div class="flex-row flex-wrap justify-start align-start">
    <pbc-toggle-button v-model='selections[transformsAndSource.c.id]' v-for='transformsAndSource in transformsAndSources' :key='transformsAndSource.c.id' class="max-height-collision-targets">
      <toy-from-component class="p-2" :transforms-and-source='transformsAndSource'  />
    </pbc-toggle-button>
    <div v-if='toplevelTransforms.length' class="bg-blue-400 m-1 rounded flex">
      <div class="w-16 rounded bg-blue-300">
        <img class="float-left w-12 h-12 p-1" src='/PBC_logo.svg' />
      </div>
      <div>
        <h1 class="ml-2 text-sm text-white align-center font-semibold tracking-loose">
          <span v-if='!transformsAndSources.length'>You do not have any collision boxes, yet...</span>
          <span v-else>There are some toys without collision boxes.</span>
        </h1>
        <div class="text-center p-1">
          <pbc-button @click='showChooseDialog = true'>
            <plus-circle />
            Add
          </pbc-button>
        </div>
      </div>
    </div>

    <choose-transforms-dialog v-if='showChooseDialog'
                            :transforms-and-sources='toplevelTransforms' 
                            @close='showChooseDialog = false'
                            @done='addCollisionBoxes' />

  </div>
</template>

<script>
import PlusCircle from '@icons/PlusCircle.vue';
import Treeutil from '@edit/tree/treeutil.js';
import * as ComponentsDb from '@edit/tree/componentsdb.js';
import ChooseTransformsDialog from '@ui/organisms/ChooseTransformsDialog.vue';
import { uniq, fromPairs, toPairs, flatten } from 'lodash';
import { abstractField } from "vue-form-generator";
import ToyFromComponent from '@edit/molecules/ToyFromComponent.vue';
export default {
  mixins: [ abstractField ],
  data() {
    const selections = {};

    const transformsAndSources = [];
    const toplevelTransforms = [];
    return {
      transformsAndSources,
      toplevelTransforms,
      selections,
      showChooseDialog: false,
    }
  },
  mounted() {
    this.update();
  },
  components:{
    ToyFromComponent,
    ChooseTransformsDialog,
    PlusCircle
  },
  methods: {
    addCollisionBoxes(components) {
      console.log('schema', this.vfg.schema);
      const {partutil, transform} = this.vfg.schema.data;
      const component = partutil.getComponentById(transform.cid);

      const uniqIds = uniq(components.concat([component.id]));
      uniqIds.forEach( (id) => {
        const component = partutil.getComponentById(id);
        const treeutil = new Treeutil(partutil.from);
        const newComponent = partutil.addComponent(ComponentsDb.createComponent("collisionBox"));
        treeutil.addLink({name:'link'}, component, newComponent);

        this.value.push(newComponent.id);
      });
      this.showChooseDialog = false;
      this.update();
    },
    update() {
      const {partutil} = this.vfg.schema.data;
      const componentTypes = this.schema.componentTypes;
      const physicsFilter = partutil.gamedata.filterComponentsByType(componentTypes);
      const physicsboxesAndSources = partutil.gamedata.findComponentsAndSourceByFilter(physicsFilter);
      const transformsAndSources = partutil.gamedata.findTransformsAndSourceForComponentsAndSource(physicsboxesAndSources);

      const gamedata = partutil.gamedata;
      const toplevelTransforms = flatten(partutil.from.transforms||[]
        .filter( (transform) => {
          const component = partutil.getComponentById(transform.cid);
          if (component.type === 'camera') {
            return false;
          }
          const {components} = partutil.findComponentsAndLinksFrom(component);
          return components.filter( ({type}) => {
            return type === 'collisionBox';
          }).length === 0;
          //const 
        })
        .map( (transform) => {
          const filter = gamedata.filterComponentsByTransform(transform);
          const sources = partutil.gamedata.findComponentsAndSourceByFilter(filter);
          const transformsAndSources = partutil.gamedata.findTransformsAndSourceForComponentsAndSource(sources);
          return transformsAndSources;
        }));

      physicsboxesAndSources.forEach( ({c}) => {
        this.$set(this.selections, c.id, this.value.indexOf(c.id) !== -1);
      });

      this.transformsAndSources = transformsAndSources;
      this.toplevelTransforms = toplevelTransforms;

    }
  },
  watch: {

    selections: {
      handler(nv) {
        this.value = Object.keys(fromPairs(toPairs(nv).filter( ([key,value]) => {
          return value;
        })));
      },
      deep: true
    }
  },
}
</script>
<style scoped>
.max-height-collision-targets {
  max-height:150px;
  overflow-y:auto;
}
</style>
